import { Component } from '@angular/core';

@Component({
    selector: 'pdhstar-card-manager-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor() {
    }

}
